import React, { Component } from 'react';
import Notice from './Notice';
import Backlog from './Backlog';
import { connect } from 'react-redux';


class NoticePage extends Component {

    state = {
        activeKey: 'Backlog',
        searchParams:{},
    }

    componentDidMount(){
        const { searchParams } = this.props;
        const { activeKey = 'Backlog' } = searchParams;
        this.setState({ activeKey, searchParams });
    }

    handleTabClick = activeKey => {
        this.setState({ activeKey, searchParams:{} });
    }

    render() {
        const { activeKey, searchParams } = this.state;
        const panes = [
            { title: '待办事项', key: 'Backlog', content: '' },
            { title: '消息通知', key: 'Notice', content: '' },
        ];
        return (
            <div>
                {
                    activeKey == 'Notice' ? 
                    <Notice 
                        panes={panes}
                        activeKey={activeKey}
                        params={searchParams}
                        handleTabClick={this.handleTabClick}
                        ref={el => this.notieceRef = el} 
                    /> : 
                    <Backlog 
                        panes={panes}
                        activeKey={activeKey}
                        params={searchParams}
                        handleTabClick={this.handleTabClick}
                        ref={el => this.backlogRef = el}
                    />
                }
            </div>
        );
    }
}


const mapSateToProps = (state) => ({
    searchParams: state.noticeState.searchParams || {},
});

export default connect(mapSateToProps)(NoticePage);



// WEBPACK FOOTER //
// ./src/components/layout/notice/index.js